import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Hook to dynamically update the document's lang attribute
 * based on the current i18next language.
 * This enables :lang() CSS selectors to work correctly.
 */
export function useDocumentLang() {
  const { i18n } = useTranslation()

  useEffect(() => {
    document.documentElement.lang = i18n.language
  }, [i18n.language])
}
